export default __webpack_public_path__ + "static/media/About_IMG-Guidance.f8ef9deb.png";